<div class="add-policy" [formGroup]="addPolicyFormGroup">
  <app-popup-top-line></app-popup-top-line>
  <div class="add-policy-header">
    <div class="title">{{ 'policyPage.addPolicy' | labelsProvider }}</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="add-policy-body">
    <div class="input">
      <input [placeholder]="'policyPage.enterPolicyName' | labelsProvider" type="text" formControlName="policyName" />
    </div>
    <div class="drop-down-field">
      <app-select
        class="policy-field-box"
        placeHolder="Policy Type"
        [options]="policyTypes"
        (optionOnSelection)="onPolicyTypeSelection($event)"
      >
      </app-select>
    </div>
  </div>
  <div class="add-policy-footer">
    <button class="cancel" (click)="onClose()">
      {{ 'common.cancel' | labelsProvider }}
    </button>
    <button
      class="confirm"
      [ngClass]="{
        'confirm-disabled': addPolicyFormGroup.invalid || waitingForResponse,
      }"
      (click)="addPolicy()"
      cdkFocusInitial
      [disabled]="addPolicyFormGroup.invalid || waitingForResponse"
    >
      <span *ngIf="!waitingForResponse">{{ 'common.add' | labelsProvider }}</span>
      <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </button>
  </div>
</div>
